import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-geosearch/dist/geosearch.css';
import { useState, useEffect } from 'react';
import L from 'leaflet';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import LocationMarker from './LocationMarker';
import SearchControl from './SearchControl';
import { useDispatch } from 'react-redux';
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css';
import 'leaflet-gesture-handling';
import { GestureHandling } from 'leaflet-gesture-handling';
// Atur icon default Leaflet
const DefaultIcon = L.icon({
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
});

L.Marker.prototype.options.icon = DefaultIcon;

L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);

const MapWithSearch = ({ initialPosition, onLocationChange, readOnly = false }) => {
    const [position, setPosition] = useState(initialPosition);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!readOnly) {
            dispatch(onLocationChange({ latitude: position.lat, longitude: position.lng }));
        }
    }, [position, readOnly]);

    return (
        <div>
            <MapContainer center={position} zoom={13} style={{ height: '500px', width: '100%', zIndex: '2' }} scrollWheelZoom={false} gestureHandling={true}>
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />

                {!readOnly && <SearchControl onLocationSelect={setPosition} />}
                {!readOnly && <LocationMarker onLocationSelect={setPosition} currentPosition={position} />}

                <Marker position={position}>
                    <Popup>
                        Latitude: {position.lat} <br />
                        Longitude: {position.lng}
                    </Popup>
                </Marker>
            </MapContainer>
        </div>
    );
};

export default MapWithSearch;
